module.exports = __webpack_public_path__ + "static/media/YF31_0.38a2f8f5.jpg";